// const supportedLanguages = [
//     'en', 'ru', 'es', 'de', 'fr', 'it', 'pt', 'pl', 'tr', 'nl', 'sv', 'fi',
//     'da', 'no', 'cs', 'hu', 'ro', 'el', 'ja', 'ko', 'zh-CN', 'ar', 'he',
//     'th', 'uk'
// ];

export const TRANSLATIONS: Record<string, Record<string, string>> = {
    en: {
        "modal.title": "Tell us about these topics",
        "modal.subtitle": "We understand any language, fill everything in, and translate if needed",

        "loader.initial": "Preparing form...",

        "button.startSpeaking": "Start Speaking",
        "button.stopSpeaking": "Stop Recording",
        "button.tryAgain": "Try Again",

        "listening.title": "Listening...",
        "listening.subtitle": "Speak naturally about what you want to fill",
        "listening.fieldsToFill": "Fields to fill",

        "processing.title": "Processing...",
        "processing.subtitle": "Understanding your input",
        "processing.analyzingForm": "Analyzing form fields",

        "success.title": "Form Filled!",
        "success.subtitle": "Review the filled fields and submit when ready",
        "success.what_was_filled": "What was filled?",
        "success.you_said": "You said",
        "success.we_translated": "We translated",
        "success.apply_changes": "Fill and review",
        "success.cancel_and_return": "Cancel and return to form",
        "success.no_filled_data": "No data about filled fields",
        "success.unfilled_fields_title": "Some fields could not be filled",
        "success.unfilled_fields_subtitle": "Please mention these values clearly:",
        "success.clarify_data": "Please clarify these details:",
        "success.empty_fields": "Not filled",
        "success.check_fields": "Check",
        "success.filled_fields": "Completed",
        "success.field_single": "field",
        "success.fields_multiple": "fields",
        "success.require_filling": "require filling",
        "success.require_attention": "require attention",
        "success.successfully_filled": "successfully filled",

        "error.microphone": "Microphone access required",
        "error.noFields": "No forms detected on this page",
        "error.noActiveForm": "No active form found for filling",
        "error.lowConfidence": "Could not clearly understand the audio. Please speak more clearly.",
        "error.general": "Something went wrong. Please try again.",
        "error.no_fields_detected": "Could not recognize information for filling the form. Please try to clearly specify what data should be entered in the fields.",
        "error.no_data_title": "Data not recognized",
        "error.showDetails": "Show technical details",

        "floatingButton.fillVoice1": "Dictate",
        "floatingButton.fillVoice2": "Fill",

        "form.status.active": "active",
        "form.status.partial": "partially filled",
        "form.status.filled": "filled",
        "form.progress.filled": "{count} filled",
        "form.progress.partial": "{count} field partially filled",
        "form.progress.scrollToSelect": "Scroll to select",
        "form.defaultName": "Form",
        "form.formNumber": "Form {current} of {total}",
        "form.allForms": "All {count} forms",
        
        "help.title": "Help",
        "settings.title": "Settings",
        "gesture.swipeToClose": "Swipe to close",
        "button.close": "Close",
        "success.review_warnings": "Review warnings",
    },

    ru: {
        "modal.title": "Расскажите об этих темах",
        "modal.subtitle": "Мы поймём любой язык, всё заполним и, если нужно, переведём",

        "loader.initial": "Подготовка формы...",

        "button.startSpeaking": "Начните говорить",
        "button.stopSpeaking": "Остановить запись",
        "button.tryAgain": "Попробовать снова",

        "listening.title": "Слушаю...",
        "listening.subtitle": "Говорите естественно о том, что нужно заполнить",
        "listening.fieldsToFill": "Поля для заполнения",

        "processing.title": "Обрабатываю...",
        "processing.subtitle": "Понимаю ваш запрос",
        "processing.analyzingForm": "Анализирую поля формы",

        "success.title": "Форма заполнена!",
        "success.subtitle": "Проверьте заполненные поля и отправьте",
        "success.what_was_filled": "Что именно заполнено?",
        "success.you_said": "Вы сказали",
        "success.we_translated": "Мы перевели",
        "success.apply_changes": "Заполнить и проверить",
        "success.cancel_and_return": "Отменить и вернуться к форме",
        "success.no_filled_data": "Нет данных о заполненных полях",
        "success.unfilled_fields_title": "Некоторые поля не удалось заполнить",
        "success.unfilled_fields_subtitle": "Пожалуйста, укажите эти значения более четко:",
        "success.clarify_data": "Уточните эти данные:",
        "success.legend_filled": "Заполнено",
        "success.legend_check": "Требует проверки",
        "success.legend_empty": "Не заполнено",
        "success.empty_fields": "Не заполнено",
        "success.check_fields": "Проверьте",
        "success.filled_fields": "Готово",
        "success.field_single": "поле",
        "success.fields_multiple": "поля",
        "success.require_filling": "требуют заполнения",
        "success.require_attention": "требуют внимания",
        "success.successfully_filled": "успешно заполнено",

        "error.microphone": "Требуется доступ к микрофону",
        "error.noFields": "Формы не обнаружены на этой странице",
        "error.noActiveForm": "Не найдена активная форма для заполнения",
        "error.lowConfidence": "Не удалось четко распознать речь. Пожалуйста, говорите более отчетливо.",
        "error.general": "Что-то пошло не так. Попробуйте еще раз.",
        "error.no_fields_detected": "Не удалось распознать информацию для заполнения формы. Попробуйте четче указать, какие данные нужно ввести в поля.",
        "error.no_data_title": "Данные не распознаны",
        "error.showDetails": "Показать технические детали",


        "floatingButton.fillVoice1": "Диктуй",
        "floatingButton.fillVoice2": "Заполняй",

        "form.status.active": "активная",
        "form.status.partial": "частично заполнена",
        "form.status.filled": "заполнена",
        "form.progress.filled": "{count} заполнено",
        "form.progress.partial": "{count} поле частично заполнено",
        "form.progress.scrollToSelect": "Прокрутите для выбора",
        "form.defaultName": "Форма",
        "form.formNumber": "Форма {current} из {total}",
        "form.allForms": "Все {count} формы",
        
        "help.title": "Помощь",
        "settings.title": "Настройки",
        "gesture.swipeToClose": "Смахните для закрытия",
        "button.close": "Закрыть",
        "success.review_warnings": "Просмотреть предупреждения",
    },

    es: {
        "modal.title": "Cuéntanos sobre estos temas",
        "modal.subtitle": "Entendemos cualquier idioma, completa todo y traduce si es necesario",

        "button.startSpeaking": "Comenzar a hablar",
        "button.stopSpeaking": "Detener grabación",
        "button.tryAgain": "Intentar de nuevo",

        "listening.title": "Escuchando...",
        "listening.subtitle": "Habla de forma natural sobre lo que deseas rellenar",

        "processing.title": "Procesando...",
        "processing.subtitle": "Entendiendo tu entrada",
        "processing.analyzingForm": "Analizando campos del formulario",

        "success.title": "¡Formulario rellenado!",
        "success.subtitle": "Revisa los campos rellenados y envía cuando estés listo",
        "success.what_was_filled": "¿Qué se llenó?",
        "success.you_said": "Dijiste",
        "success.we_translated": "Traducimos",
        "success.apply_changes": "Completar y revisar",
        "success.cancel_and_return": "Cancelar y volver al formulario",
        "success.no_filled_data": "No hay datos sobre campos rellenados",
        "success.unfilled_fields_title": "Algunos campos no se pudieron rellenar",
        "success.unfilled_fields_subtitle": "Por favor, menciona estos valores más claramente:",
        "success.clarify_data": "Por favor aclare estos datos:",
        "success.empty_fields": "No completado",
        "success.check_fields": "Verificar",
        "success.filled_fields": "Completado",
        "success.field_single": "campo",
        "success.fields_multiple": "campos",
        "success.require_filling": "requieren llenado",
        "success.require_attention": "requieren atención",
        "success.successfully_filled": "llenado exitosamente",

        "error.microphone": "Se requiere acceso al micrófono",
        "error.noFields": "No se detectaron formularios en esta página",
        "error.noActiveForm": "No se encontró un formulario activo para rellenar",
        "error.lowConfidence": "No se pudo entender claramente el audio. Por favor, habla más claramente.",
        "error.general": "Algo salió mal. Por favor, inténtalo de nuevo.",
        "error.no_fields_detected": "No se pudo reconocer información para rellenar el formulario. Por favor, intenta especificar más claramente qué datos deben ingresarse en los campos.",
        "error.no_data_title": "Datos no reconocidos",
        "error.showDetails": "Mostrar detalles técnicos",
        
        "loader.initial": "Preparando formulario...",

        "floatingButton.fillVoice1": "Dicta",
        "floatingButton.fillVoice2": "Completa",

        "form.status.active": "activo",
        "form.status.partial": "parcialmente rellenado",
        "form.status.filled": "rellenado",
        "form.progress.filled": "{count} rellenado",
        "form.progress.partial": "{count} campo parcialmente llenado",
        "form.progress.scrollToSelect": "Desplázate para seleccionar",
        "form.defaultName": "Formulario",
        "form.formNumber": "Formulario {current} de {total}",
        "form.allForms": "Todos los {count} formularios",
    },

    fr: {
        "modal.title": "Parlez-nous de ces sujets",
        "modal.subtitle": "Nous comprenons toutes les langues, remplissez tout et traduisez si nécessaire",

        "button.startSpeaking": "Commencer à parler",
        "button.stopSpeaking": "Arrêter l'enregistrement",
        "button.tryAgain": "Réessayer",

        "listening.title": "Écoute...",
        "listening.subtitle": "Parlez naturellement de ce que vous voulez remplir",

        "processing.title": "Traitement...",
        "processing.subtitle": "Compréhension de votre saisie",
        "processing.analyzingForm": "Analyse des champs du formulaire",

        "success.title": "Formulaire rempli !",
        "success.subtitle": "Vérifiez les champs remplis et envoyez lorsque vous êtes prêt",
        "success.what_was_filled": "Qu'est-ce qui a été rempli ?",
        "success.you_said": "Vous avez dit",
        "success.we_translated": "Nous avons traduit",
        "success.apply_changes": "Remplir et vérifier",
        "success.cancel_and_return": "Annuler et retourner au formulaire",
        "success.no_filled_data": "Aucune donnée sur les champs remplis",
        "success.unfilled_fields_title": "Certains champs n'ont pas pu être remplis",
        "success.unfilled_fields_subtitle": "Veuillez mentionner ces valeurs plus clairement :",
        "success.clarify_data": "Veuillez clarifier ces données:",
        "success.empty_fields": "Non rempli",
        "success.check_fields": "Vérifier",
        "success.filled_fields": "Complété",
        "success.field_single": "champ",
        "success.fields_multiple": "champs",
        "success.require_filling": "nécessitent un remplissage",
        "success.require_attention": "nécessitent une attention",
        "success.successfully_filled": "rempli avec succès",

        "error.microphone": "Accès au microphone requis",
        "error.noFields": "Aucun formulaire détecté sur cette page",
        "error.noActiveForm": "Aucun formulaire actif trouvé pour le remplissage",
        "error.lowConfidence": "Impossible de comprendre clairement l'audio. Veuillez parler plus clairement.",
        "error.general": "Une erreur est survenue. Veuillez réessayer.",
        "error.no_fields_detected": "Impossible de reconnaître les informations pour remplir le formulaire. Veuillez essayer de spécifier plus clairement quelles données doivent être saisies dans les champs.",
        "error.no_data_title": "Données non reconnues",
        "error.showDetails": "Afficher les détails techniques",
        
        "loader.initial": "Préparation du formulaire...",

        "floatingButton.fillVoice1": "Dicte",
        "floatingButton.fillVoice2": "Remplis",

        "form.status.active": "actif",
        "form.status.partial": "partiellement rempli",
        "form.status.filled": "rempli",
        "form.progress.filled": "{count} rempli",
        "form.progress.partial": "{count} champ partiellement rempli",
        "form.progress.scrollToSelect": "Faites défiler pour sélectionner",
        "form.defaultName": "Formulaire",
        "form.formNumber": "Formulaire {current} sur {total}",
        "form.allForms": "Tous les {count} formulaires",
    },

    de: {
        "modal.title": "Erzählen Sie uns von diesen Themen",
        "modal.subtitle": "Wir verstehen jede Sprache, füllen alles aus und übersetzen bei Bedarf",

        "button.startSpeaking": "Sprechen beginnen",
        "button.stopSpeaking": "Aufnahme stoppen",
        "button.tryAgain": "Erneut versuchen",

        "listening.title": "Zuhören...",
        "listening.subtitle": "Sprechen Sie natürlich über das, was Sie ausfüllen möchten",

        "processing.title": "Verarbeitung...",
        "processing.subtitle": "Verstehe Ihre Eingabe",
        "processing.analyzingForm": "Analysiere Formularfelder",

        "success.title": "Formular ausgefüllt!",
        "success.subtitle": "Überprüfen Sie die ausgefüllten Felder und senden Sie, wenn Sie bereit sind",
        "success.what_was_filled": "Was wurde ausgefüllt?",
        "success.you_said": "Sie sagten",
        "success.we_translated": "Wir übersetzten",
        "success.apply_changes": "Ausfüllen und überprüfen",
        "success.cancel_and_return": "Abbrechen und zum Formular zurückkehren",
        "success.no_filled_data": "Keine Daten über ausgefüllte Felder",
        "success.unfilled_fields_title": "Einige Felder konnten nicht ausgefüllt werden",
        "success.unfilled_fields_subtitle": "Bitte geben Sie diese Werte deutlicher an:",
        "success.clarify_data": "Bitte klären Sie diese Daten:",
        "success.empty_fields": "Nicht ausgefüllt",
        "success.check_fields": "Überprüfen",
        "success.filled_fields": "Ausgefüllt",
        "success.field_single": "Feld",
        "success.fields_multiple": "Felder",
        "success.require_filling": "müssen ausgefüllt werden",
        "success.require_attention": "benötigen Aufmerksamkeit",
        "success.successfully_filled": "erfolgreich ausgefüllt",

        "error.microphone": "Mikrofonzugriff erforderlich",
        "error.noFields": "Keine Formulare auf dieser Seite gefunden",
        "error.noActiveForm": "Kein aktives Formular zum Ausfüllen gefunden",
        "error.lowConfidence": "Audio konnte nicht klar verstanden werden. Bitte sprechen Sie deutlicher.",
        "error.general": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        "error.no_fields_detected": "Die Informationen zum Ausfüllen des Formulars konnten nicht erkannt werden. Bitte versuchen Sie, genauer anzugeben, welche Daten in die Felder eingegeben werden sollen.",
        "error.no_data_title": "Daten nicht erkannt",
        "error.showDetails": "Technische Details anzeigen",
        
        "loader.initial": "Formular wird vorbereitet...",

        "floatingButton.fillVoice1": "Diktiere",
        "floatingButton.fillVoice2": "Fülle aus",

        "form.status.active": "aktiv",
        "form.status.partial": "teilweise ausgefüllt",
        "form.status.filled": "ausgefüllt",
        "form.progress.filled": "{count} ausgefüllt",
        "form.progress.partial": "{count} Feld teilweise ausgefüllt",
        "form.progress.scrollToSelect": "Scrollen zur Auswahl",
        "form.defaultName": "Formular",
        "form.formNumber": "Formular {current} von {total}",
        "form.allForms": "Alle {count} Formulare",
    },
    pl: {
        "modal.title": "Opowiedz nam o tych tematach",
        "modal.subtitle": "Rozumiemy każdy język, wypełnimy wszystko i przetłumaczymy w razie potrzeby",

        "button.startSpeaking": "Rozpocznij mówienie",
        "button.stopSpeaking": "Zatrzymaj nagrywanie",
        "button.tryAgain": "Spróbuj ponownie",

        "listening.title": "Słucham...",
        "listening.subtitle": "Mów naturalnie o tym, co chcesz wypełnić",

        "processing.title": "Przetwarzam...",
        "processing.subtitle": "Rozumiem Twoje wejście",
        "processing.analyzingForm": "Analizuję pola formularza",

        "success.title": "Formularz wypełniony!",
        "success.subtitle": "Sprawdź wypełnione pola i wyślij, gdy będziesz gotowy",
        "success.what_was_filled": "Co zostało wypełnione?",
        "success.you_said": "Powiedziałeś",
        "success.we_translated": "Przetłumaczyliśmy",
        "success.apply_changes": "Wypełnij i sprawdź",
        "success.cancel_and_return": "Anuluj i wróć do formularza",
        "success.no_filled_data": "Brak danych o wypełnionych polach",
        "success.unfilled_fields_title": "Niektóre pola nie mogły zostać wypełnione",
        "success.unfilled_fields_subtitle": "Proszę podać te wartości bardziej wyraźnie:",
        "success.clarify_data": "Proszę wyjaśnić te dane:",
        "success.empty_fields": "Niewypełnione",
        "success.check_fields": "Sprawdź",
        "success.filled_fields": "Wypełnione",
        "success.field_single": "pole",
        "success.fields_multiple": "pola",
        "success.require_filling": "wymagają wypełnienia",
        "success.require_attention": "wymagają uwagi",
        "success.successfully_filled": "wypełnione pomyślnie",

        "error.microphone": "Wymagany dostęp do mikrofonu",
        "error.noFields": "Nie wykryto formularzy na tej stronie",
        "error.noActiveForm": "Nie znaleziono aktywnego formularza do wypełnienia",
        "error.lowConfidence": "Nie można było wyraźnie zrozumieć audio. Proszę mówić wyraźniej.",
        "error.general": "Coś poszło nie tak. Spróbuj ponownie.",
        "error.no_fields_detected": "Nie udało się rozpoznać informacji do wypełnienia formularza. Spróbuj dokładniej określić, jakie dane należy wprowadzić w pola.",
        "error.no_data_title": "Dane nie zostały rozpoznane",
        "error.showDetails": "Pokaż szczegóły techniczne",
        
        "loader.initial": "Przygotowuję formularz...",

        "floatingButton.fillVoice1": "Dyktuj",
        "floatingButton.fillVoice2": "Wypełniaj",

        "form.status.active": "aktywny",
        "form.status.partial": "częściowo wypełniony",
        "form.status.filled": "wypełniony",
        "form.progress.filled": "{count} wypełniono",
        "form.progress.partial": "{count} pole częściowo wypełnione",
        "form.progress.scrollToSelect": "Przewiń, aby wybrać",
        "form.defaultName": "Formularz",
        "form.formNumber": "Formularz {current} z {total}",
        "form.allForms": "Wszystkie {count} formularze",
    },
    it: {
        "modal.title": "Raccontaci di questi argomenti",
        "modal.subtitle": "Comprendiamo qualsiasi lingua, compiliamo tutto e traduciamo se necessario",

        "button.startSpeaking": "Inizia a parlare",
        "button.stopSpeaking": "Interrompi registrazione",
        "button.tryAgain": "Riprova",

        "listening.title": "Ascoltando...",
        "listening.subtitle": "Parla naturalmente di ciò che vuoi compilare",

        "processing.title": "Elaborazione...",
        "processing.subtitle": "Comprendo il tuo input",
        "processing.analyzingForm": "Analisi dei campi del modulo",

        "success.title": "Modulo compilato!",
        "success.subtitle": "Rivedi i campi compilati e invia quando sei pronto",
        "success.what_was_filled": "Cosa è stato compilato?",
        "success.you_said": "Hai detto",
        "success.we_translated": "Abbiamo tradotto",
        "success.apply_changes": "Compila e verifica",
        "success.cancel_and_return": "Annulla e torna al modulo",
        "success.no_filled_data": "Nessun dato sui campi compilati",
        "success.unfilled_fields_title": "Alcuni campi non sono stati compilati",
        "success.unfilled_fields_subtitle": "Per favore indica questi valori più chiaramente:",
        "success.clarify_data": "Si prega di chiarire questi dati:",
        "success.empty_fields": "Non compilato",
        "success.check_fields": "Verifica",
        "success.filled_fields": "Completato",
        "success.field_single": "campo",
        "success.fields_multiple": "campi",
        "success.require_filling": "richiedono compilazione",
        "success.require_attention": "richiedono attenzione",
        "success.successfully_filled": "compilato con successo",

        "error.microphone": "È necessario l'accesso al microfono",
        "error.noFields": "Nessun modulo rilevato in questa pagina",
        "error.noActiveForm": "Nessun modulo attivo trovato per la compilazione",
        "error.lowConfidence": "Non è stato possibile comprendere chiaramente l'audio. Parla più chiaramente.",
        "error.general": "Qualcosa è andato storto. Riprova.",
        "error.no_fields_detected": "Non è stato possibile riconoscere le informazioni per compilare il modulo. Prova a specificare più chiaramente quali dati devono essere inseriti nei campi.",
        "error.no_data_title": "Dati non riconosciuti",
        "error.showDetails": "Mostra dettagli tecnici",
        
        "loader.initial": "Preparazione del modulo...",

        "floatingButton.fillVoice1": "Detta",
        "floatingButton.fillVoice2": "Compila",

        "form.status.active": "attivo",
        "form.status.partial": "parzialmente compilato",
        "form.status.filled": "compilato",
        "form.progress.filled": "{count} compilato",
        "form.progress.partial": "{count} campo parzialmente compilato",
        "form.progress.scrollToSelect": "Scorri per selezionare",
        "form.defaultName": "Modulo",
        "form.formNumber": "Modulo {current} di {total}",
        "form.allForms": "Tutti i {count} moduli",
    },
    pt: {
        "modal.title": "Conte-nos sobre esses tópicos",
        "modal.subtitle": "Entendemos qualquer idioma, preencha tudo e traduza se necessário",

        "loader.initial": "Preparando formulário...",

        "button.startSpeaking": "Começar a falar",
        "button.stopSpeaking": "Parar gravação",
        "button.tryAgain": "Tentar novamente",

        "listening.title": "Ouvindo...",
        "listening.subtitle": "Fale naturalmente sobre o que deseja preencher",

        "processing.title": "Processando...",
        "processing.subtitle": "Entendendo sua entrada",
        "processing.analyzingForm": "Analisando campos do formulário",

        "success.title": "Formulário preenchido!",
        "success.subtitle": "Revise os campos preenchidos e envie quando estiver pronto",
        "success.what_was_filled": "O que foi preenchido?",
        "success.you_said": "Você disse",
        "success.we_translated": "Nós traduzimos",
        "success.apply_changes": "Preencher e revisar",
        "success.cancel_and_return": "Cancelar e voltar ao formulário",
        "success.no_filled_data": "Nenhum dado sobre campos preenchidos",
        "success.unfilled_fields_title": "Alguns campos não puderam ser preenchidos",
        "success.unfilled_fields_subtitle": "Por favor, mencione estes valores mais claramente:",
        "success.clarify_data": "Por favor, esclareça estes dados:",
        "success.empty_fields": "Não preenchido",
        "success.check_fields": "Verificar",
        "success.filled_fields": "Preenchido",
        "success.field_single": "campo",
        "success.fields_multiple": "campos",
        "success.require_filling": "requerem preenchimento",
        "success.require_attention": "requerem atenção",
        "success.successfully_filled": "preenchido com sucesso",

        "error.microphone": "Acesso ao microfone necessário",
        "error.noFields": "Nenhum formulário detectado nesta página",
        "error.noActiveForm": "Nenhum formulário ativo encontrado para preenchimento",
        "error.lowConfidence": "Não foi possível entender claramente o áudio. Por favor, fale mais claramente.",
        "error.general": "Algo deu errado. Por favor, tente novamente.",
        "error.no_fields_detected": "Não foi possível reconhecer informações para preencher o formulário. Por favor, tente especificar mais claramente quais dados devem ser inseridos nos campos.",
        "error.no_data_title": "Dados não reconhecidos",
        "error.showDetails": "Mostrar detalhes técnicos",

        "floatingButton.fillVoice1": "Dite",
        "floatingButton.fillVoice2": "Preencha",

        "form.status.active": "ativo",
        "form.status.partial": "parcialmente preenchido",
        "form.status.filled": "preenchido",
        "form.progress.filled": "{count} preenchido",
        "form.progress.partial": "{count} campo parcialmente llenado",
        "form.progress.scrollToSelect": "Role para selecionar",
        "form.defaultName": "Formulário",
        "form.formNumber": "Formulário {current} de {total}",
        "form.allForms": "Todos os {count} formulários"
    },
    zh: {
        "modal.title": "告诉我们这些主题",
        "modal.subtitle": "我们可以理解任何语言，自动填写所有内容，并在需要时翻译",

        "loader.initial": "正在准备表单...",

        "button.startSpeaking": "开始说话",
        "button.stopSpeaking": "停止录制",
        "button.tryAgain": "重试",

        "listening.title": "正在聆听...",
        "listening.subtitle": "请自然地说出您想要填写的内容",

        "processing.title": "正在处理...",
        "processing.subtitle": "正在理解您的输入",
        "processing.analyzingForm": "正在分析表单字段",

        "success.title": "表单已填写！",
        "success.subtitle": "查看已填写的字段，准备好后提交",
        "success.what_was_filled": "填写了什么？",
        "success.you_said": "您说了",
        "success.we_translated": "我们翻译了",
        "success.apply_changes": "填写并检查",
        "success.cancel_and_return": "取消并返回表单",
        "success.no_filled_data": "没有已填写字段的数据",
        "success.unfilled_fields_title": "某些字段无法填写",
        "success.unfilled_fields_subtitle": "请更清楚地说明这些值：",
        "success.clarify_data": "请澄清这些数据：",
        "success.empty_fields": "未填写",
        "success.check_fields": "检查",
        "success.filled_fields": "已完成",
        "success.field_single": "字段",
        "success.fields_multiple": "字段",
        "success.require_filling": "需要填写",
        "success.require_attention": "需要注意",
        "success.successfully_filled": "成功填写",

        "error.microphone": "需要麦克风访问权限",
        "error.noFields": "此页面未检测到表单",
        "error.noActiveForm": "未找到可填写的活动表单",
        "error.lowConfidence": "无法清楚地理解音频。请说得更清楚一些。",
        "error.general": "出现错误，请重试。",
        "error.no_fields_detected": "无法识别填写表单的信息。请尝试更清楚地指定应在字段中输入哪些数据。",
        "error.no_data_title": "数据未识别",
        "error.showDetails": "显示技术细节",

        "floatingButton.fillVoice1": "口述",
        "floatingButton.fillVoice2": "填写",

        "form.status.active": "活动",
        "form.status.partial": "部分填写",
        "form.status.filled": "已填写",
        "form.progress.filled": "{count} 已填写",
        "form.progress.partial": "{count} 个字段部分填写",
        "form.progress.scrollToSelect": "滚动选择",
        "form.defaultName": "表单",
        "form.formNumber": "表单 {current} / {total}",
        "form.allForms": "全部 {count} 个表单"
    },
    ja: {
        "modal.title": "これらのトピックについて教えてください",
        "modal.subtitle": "どの言語でも理解し、必要に応じてすべてを入力し翻訳します",

        "loader.initial": "フォームを準備しています...",

        "button.startSpeaking": "話し始める",
        "button.stopSpeaking": "録音を停止",
        "button.tryAgain": "再試行",

        "listening.title": "リッスン中...",
        "listening.subtitle": "入力したい内容を自然に話してください",

        "processing.title": "処理中...",
        "processing.subtitle": "入力を理解しています",
        "processing.analyzingForm": "フォームフィールドを分析しています",

        "success.title": "フォームが入力されました！",
        "success.subtitle": "入力されたフィールドを確認し、準備ができたら送信してください",
        "success.what_was_filled": "何が入力されましたか？",
        "success.you_said": "あなたが言ったこと",
        "success.we_translated": "翻訳した内容",
        "success.apply_changes": "入力して確認",
        "success.cancel_and_return": "キャンセルしてフォームに戻る",
        "success.no_filled_data": "入力されたフィールドのデータがありません",
        "success.unfilled_fields_title": "一部のフィールドを入力できませんでした",
        "success.unfilled_fields_subtitle": "これらの値をより明確に言及してください：",
        "success.clarify_data": "これらのデータを明確にしてください：",
        "success.empty_fields": "未入力",
        "success.check_fields": "確認",
        "success.filled_fields": "完了",
        "success.field_single": "フィールド",
        "success.fields_multiple": "フィールド",
        "success.require_filling": "入力が必要です",
        "success.require_attention": "注意が必要です",
        "success.successfully_filled": "正常に入力されました",

        "error.microphone": "マイクアクセスが必要です",
        "error.noFields": "このページにフォームが見つかりませんでした",
        "error.noActiveForm": "入力可能なアクティブなフォームが見つかりません",
        "error.lowConfidence": "音声を明確に理解できませんでした。もっとはっきりと話してください。",
        "error.general": "問題が発生しました。もう一度お試しください。",
        "error.no_fields_detected": "フォームに入力する情報を認識できませんでした。フィールドに入力すべきデータをより明確に指定してください。",
        "error.no_data_title": "データが認識されませんでした",
        "error.showDetails": "技術的な詳細を表示",

        "floatingButton.fillVoice1": "口述",
        "floatingButton.fillVoice2": "入力",

        "form.status.active": "アクティブ",
        "form.status.partial": "部分的に入力済み",
        "form.status.filled": "入力済み",
        "form.progress.filled": "{count} 入力済み",
        "form.progress.partial": "{count} 個欄位部分填寫",
        "form.progress.scrollToSelect": "スクロールして選択",
        "form.defaultName": "フォーム",
        "form.formNumber": "フォーム {current} / {total}",
        "form.allForms": "すべての {count} フォーム"
    },
    nl: {
        "modal.title": "Vertel ons over deze onderwerpen",
        "modal.subtitle": "We begrijpen elke taal, vullen alles in en vertalen indien nodig",

        "loader.initial": "Formulier voorbereiden...",

        "button.startSpeaking": "Begin te spreken",
        "button.stopSpeaking": "Opname stoppen",
        "button.tryAgain": "Opnieuw proberen",

        "listening.title": "Luisteren...",
        "listening.subtitle": "Spreek natuurlijk over wat je wilt invullen",

        "processing.title": "Bezig met verwerken...",
        "processing.subtitle": "Begrijp je invoer",
        "processing.analyzingForm": "Formuliervelden analyseren",

        "success.title": "Formulier ingevuld!",
        "success.subtitle": "Controleer de ingevulde velden en verzend wanneer je klaar bent",
        "success.what_was_filled": "Wat werd ingevuld?",
        "success.you_said": "Je zei",
        "success.we_translated": "We hebben vertaald",
        "success.apply_changes": "Invullen en controleren",
        "success.cancel_and_return": "Annuleren en terug naar formulier",
        "success.no_filled_data": "Geen gegevens over ingevulde velden",
        "success.unfilled_fields_title": "Sommige velden konden niet worden ingevuld",
        "success.unfilled_fields_subtitle": "Vermeld deze waarden duidelijker:",
        "success.clarify_data": "Verduidelijk deze gegevens:",
        "success.empty_fields": "Niet ingevuld",
        "success.check_fields": "Controleren",
        "success.filled_fields": "Voltooid",
        "success.field_single": "veld",
        "success.fields_multiple": "velden",
        "success.require_filling": "moeten worden ingevuld",
        "success.require_attention": "vereisen aandacht",
        "success.successfully_filled": "succesvol ingevuld",

        "error.microphone": "Microfoontoegang vereist",
        "error.noFields": "Geen formulieren gedetecteerd op deze pagina",
        "error.noActiveForm": "Geen actief formulier gevonden om in te vullen",
        "error.lowConfidence": "Kon de audio niet duidelijk begrijpen. Spreek alstublieft duidelijker.",
        "error.general": "Er is iets misgegaan. Probeer het opnieuw.",
        "error.no_fields_detected": "Kon de informatie voor het invullen van het formulier niet herkennen. Probeer duidelijker aan te geven welke gegevens in de velden moeten worden ingevoerd.",
        "error.no_data_title": "Gegevens niet herkend",
        "error.showDetails": "Technische details weergeven",

        "floatingButton.fillVoice1": "Dicteer",
        "floatingButton.fillVoice2": "Vul in",

        "form.status.active": "actief",
        "form.status.partial": "gedeeltelijk ingevuld",
        "form.status.filled": "ingevuld",
        "form.progress.filled": "{count} ingevuld",
        "form.progress.partial": "{count} veld gedeeltelijk ingevuld",
        "form.progress.scrollToSelect": "Scroll om te selecteren",
        "form.defaultName": "Formulier",
        "form.formNumber": "Formulier {current} van {total}",
        "form.allForms": "Alle {count} formulieren"
    },
    sv: {
        "modal.title": "Berätta om dessa ämnen",
        "modal.subtitle": "Vi förstår alla språk, fyller i allt och översätter vid behov",

        "loader.initial": "Förbereder formulär...",

        "button.startSpeaking": "Börja tala",
        "button.stopSpeaking": "Stoppa inspelning",
        "button.tryAgain": "Försök igen",

        "listening.title": "Lyssnar...",
        "listening.subtitle": "Tala naturligt om vad du vill fylla i",

        "processing.title": "Bearbetar...",
        "processing.subtitle": "Förstår din inmatning",
        "processing.analyzingForm": "Analyserar formulärfält",

        "success.title": "Formulär ifyllt!",
        "success.subtitle": "Granska de ifyllda fälten och skicka när du är redo",
        "success.what_was_filled": "Vad fylldes i?",
        "success.you_said": "Du sa",
        "success.we_translated": "Vi översatte",
        "success.apply_changes": "Fyll i och granska",
        "success.cancel_and_return": "Avbryt och återgå till formuläret",
        "success.no_filled_data": "Ingen data om ifyllda fält",
        "success.unfilled_fields_title": "Vissa fält kunde inte fyllas i",
        "success.unfilled_fields_subtitle": "Vänligen nämn dessa värden tydligare:",
        "success.clarify_data": "Förtydliga dessa uppgifter:",
        "success.empty_fields": "Ej ifyllt",
        "success.check_fields": "Kontrollera",
        "success.filled_fields": "Slutfört",
        "success.field_single": "fält",
        "success.fields_multiple": "fält",
        "success.require_filling": "kräver ifyllning",
        "success.require_attention": "kräver uppmärksamhet",
        "success.successfully_filled": "framgångsrikt ifyllt",

        "error.microphone": "Mikrofontillgång krävs",
        "error.noFields": "Inga formulär hittades på den här sidan",
        "error.noActiveForm": "Inget aktivt formulär hittades för ifyllning",
        "error.lowConfidence": "Kunde inte förstå ljudet tydligt. Vänligen tala tydligare.",
        "error.general": "Något gick fel. Försök igen.",
        "error.no_fields_detected": "Kunde inte känna igen information för att fylla i formuläret. Försök att tydligare ange vilka data som ska matas in i fälten.",
        "error.no_data_title": "Data kändes inte igen",
        "error.showDetails": "Visa tekniska detaljer",

        "floatingButton.fillVoice1": "Diktera",
        "floatingButton.fillVoice2": "Fyll i",

        "form.status.active": "aktiv",
        "form.status.partial": "delvis ifylld",
        "form.status.filled": "ifylld",
        "form.progress.filled": "{count} ifylld",
        "form.progress.partial": "{count} fält delvis ifyllt",
        "form.progress.scrollToSelect": "Scrolla för att välja",
        "form.defaultName": "Formulär",
        "form.formNumber": "Formulär {current} av {total}",
        "form.allForms": "Alla {count} formulär"
    },
    da: {
        "modal.title": "Fortæl os om disse emner",
        "modal.subtitle": "Vi forstår ethvert sprog, udfylder alt og oversætter om nødvendigt",

        "loader.initial": "Forbereder formular...",

        "button.startSpeaking": "Begynd at tale",
        "button.stopSpeaking": "Stop optagelse",
        "button.tryAgain": "Prøv igen",

        "listening.title": "Lytter...",
        "listening.subtitle": "Tal naturligt om, hvad du vil udfylde",

        "processing.title": "Behandler...",
        "processing.subtitle": "Forstår din input",
        "processing.analyzingForm": "Analyserer formularfelter",

        "success.title": "Formular udfyldt!",
        "success.subtitle": "Gennemse de udfyldte felter og indsend, når du er klar",
        "success.what_was_filled": "Hvad blev udfyldt?",
        "success.you_said": "Du sagde",
        "success.we_translated": "Vi oversatte",
        "success.apply_changes": "Udfyld og gennemse",
        "success.cancel_and_return": "Annuller og vend tilbage til formularen",
        "success.no_filled_data": "Ingen data om udfyldte felter",
        "success.unfilled_fields_title": "Nogle felter kunne ikke udfyldes",
        "success.unfilled_fields_subtitle": "Nævn venligst disse værdier tydeligere:",
        "success.clarify_data": "Præciser venligst disse data:",
        "success.empty_fields": "Ikke udfyldt",
        "success.check_fields": "Kontroller",
        "success.filled_fields": "Udfyldt",
        "success.field_single": "felt",
        "success.fields_multiple": "felter",
        "success.require_filling": "kræver udfyldning",
        "success.require_attention": "kræver opmærksomhed",
        "success.successfully_filled": "udfyldt med succes",

        "error.microphone": "Mikrofontilladelse påkrævet",
        "error.noFields": "Ingen formularer fundet på denne side",
        "error.noActiveForm": "Ingen aktiv formular fundet til udfyldning",
        "error.lowConfidence": "Kunne ikke forstå lyden tydeligt. Tal venligst tydeligere.",
        "error.general": "Noget gik galt. Prøv igen.",
        "error.no_fields_detected": "Kunne ikke genkende information til at udfylde formularen. Prøv at angive tydeligere hvilke data der skal indtastes i felterne.",
        "error.no_data_title": "Data ikke genkendt",
        "error.showDetails": "Vis tekniske detaljer",

        "floatingButton.fillVoice1": "Dikter",
        "floatingButton.fillVoice2": "Udfyld",

        "form.status.active": "aktiv",
        "form.status.partial": "delvist udfyldt",
        "form.status.filled": "udfyldt",
        "form.progress.filled": "{count} udfyldt",
        "form.progress.partial": "{count} felt delvist udfyldt",
        "form.progress.scrollToSelect": "Rul for at vælge",
        "form.defaultName": "Formular",
        "form.formNumber": "Formular {current} af {total}",
        "form.allForms": "Alle {count} formularer"
    },
    no: {
        "modal.title": "Fortell oss om disse emnene",
        "modal.subtitle": "Vi forstår alle språk, fyller ut alt og oversetter om nødvendig",

        "loader.initial": "Forbereder skjema...",

        "button.startSpeaking": "Begynn å snakke",
        "button.stopSpeaking": "Stopp opptak",
        "button.tryAgain": "Prøv igjen",

        "listening.title": "Lytter...",
        "listening.subtitle": "Snakk naturlig om det du vil fylle ut",

        "processing.title": "Behandler...",
        "processing.subtitle": "Forstår inndataene dine",
        "processing.analyzingForm": "Analyserer skjemafelt",

        "success.title": "Skjema fylt ut!",
        "success.subtitle": "Gå gjennom de utfylte feltene og send inn når du er klar",
        "success.what_was_filled": "Hva ble fylt ut?",
        "success.you_said": "Du sa",
        "success.we_translated": "Vi oversatte",
        "success.apply_changes": "Fyll ut og gjennomgå",
        "success.cancel_and_return": "Avbryt og gå tilbake til skjemaet",
        "success.no_filled_data": "Ingen data om utfylte felt",
        "success.unfilled_fields_title": "Noen felt kunne ikke fylles ut",
        "success.unfilled_fields_subtitle": "Vennligst nevn disse verdiene tydeligere:",
        "success.clarify_data": "Vennligst avklar disse dataene:",
        "success.empty_fields": "Ikke utfylt",
        "success.check_fields": "Sjekk",
        "success.filled_fields": "Fullført",
        "success.field_single": "felt",
        "success.fields_multiple": "felt",
        "success.require_filling": "krever utfylling",
        "success.require_attention": "krever oppmerksomhet",
        "success.successfully_filled": "vellykket utfylt",

        "error.microphone": "Mikrofontilgang kreves",
        "error.noFields": "Ingen skjemaer funnet på denne siden",
        "error.noActiveForm": "Ingen aktive skjemaer funnet for utfylling",
        "error.lowConfidence": "Kunne ikke forstå lyden tydelig. Vennligst snakk tydeligere.",
        "error.general": "Noe gikk galt. Vennligst prøv igjen.",
        "error.no_fields_detected": "Kunne ikke gjenkjenne informasjon for å fylle ut skjemaet. Vennligst prøv å spesifisere tydeligere hvilke data som skal skrives inn i feltene.",
        "error.no_data_title": "Data ikke gjenkjent",
        "error.showDetails": "Vis tekniske detaljer",

        "floatingButton.fillVoice1": "Dikter",
        "floatingButton.fillVoice2": "Fyll ut",

        "form.status.active": "aktiv",
        "form.status.partial": "delvis utfylt",
        "form.status.filled": "utfylt",
        "form.progress.filled": "{count} utfylt",
        "form.progress.partial": "{count} fält delvis ifyllt",
        "form.progress.scrollToSelect": "Rull for å velge",
        "form.defaultName": "Skjema",
        "form.formNumber": "Skjema {current} av {total}",
        "form.allForms": "Alle {count} skjemaer"
    },
    fi: {
        "modal.title": "Kerro meille näistä aiheista",
        "modal.subtitle": "Ymmärrämme mitä tahansa kieltä, täytämme kaiken ja käännämme tarvittaessa",

        "loader.initial": "Valmistellaan lomaketta...",

        "button.startSpeaking": "Aloita puhuminen",
        "button.stopSpeaking": "Lopeta tallennus",
        "button.tryAgain": "Yritä uudelleen",

        "listening.title": "Kuunnellaan...",
        "listening.subtitle": "Puhu luonnollisesti siitä, mitä haluat täyttää",

        "processing.title": "Käsittelemme...",
        "processing.subtitle": "Ymmärretään syötteesi",
        "processing.analyzingForm": "Analysoidaan lomakkeen kenttiä",

        "success.title": "Lomake täytetty!",
        "success.subtitle": "Tarkista täytetyt kentät ja lähetä, kun olet valmis",
        "success.what_was_filled": "Mitä täytettiin?",
        "success.you_said": "Sanoitte",
        "success.we_translated": "Käännetty",
        "success.apply_changes": "Täytä ja tarkista",
        "success.cancel_and_return": "Peruuta ja palaa lomakkeeseen",
        "success.no_filled_data": "Ei tietoja täytetyistä kentistä",
        "success.unfilled_fields_title": "Joitakin kenttiä ei voitu täyttää",
        "success.unfilled_fields_subtitle": "Mainitse nämä arvot selkeämmin:",
        "success.clarify_data": "Tarkenna nämä tiedot:",
        "success.empty_fields": "Ei täytetty",
        "success.check_fields": "Tarkista",
        "success.filled_fields": "Valmis",
        "success.field_single": "kenttä",
        "success.fields_multiple": "kenttää",
        "success.require_filling": "vaativat täyttämistä",
        "success.require_attention": "vaativat huomiota",
        "success.successfully_filled": "täytetty onnistuneesti",

        "error.microphone": "Mikrofonin käyttöoikeus vaaditaan",
        "error.noFields": "Tämän sivun lomakkeita ei löytynyt",
        "error.noActiveForm": "Aktiivista lomaketta ei löytynyt täytettäväksi",
        "error.lowConfidence": "Ääntä ei voitu ymmärtää selkeästi. Puhu selkeämmin.",
        "error.general": "Jotain meni pieleen. Yritä uudelleen.",
        "error.no_fields_detected": "Lomakkeen täyttämiseen tarvittavia tietoja ei tunnistettu. Yritä määrittää selkeämmin, mitä tietoja kenttiin tulee syöttää.",
        "error.no_data_title": "Tietoja ei tunnistettu",
        "error.showDetails": "Näytä tekniset tiedot",

        "floatingButton.fillVoice1": "Sanele",
        "floatingButton.fillVoice2": "Täytä",

        "form.status.active": "aktiivinen",
        "form.status.partial": "osittain täytetty",
        "form.status.filled": "täytetty",
        "form.progress.filled": "{count} täytetty",
        "form.progress.partial": "{count} kenttä osittain täytetty",
        "form.progress.scrollToSelect": "Vieritä valitaksesi",
        "form.defaultName": "Lomake",
        "form.formNumber": "Lomake {current} / {total}",
        "form.allForms": "Kaikki {count} lomaketta"
    },
    el: {
        "modal.title": "Πείτε μας για αυτά τα θέματα",
        "modal.subtitle": "Καταλαβαίνουμε κάθε γλώσσα, συμπληρώνουμε τα πάντα και μεταφράζουμε αν χρειαστεί",

        "loader.initial": "Προετοιμασία φόρμας...",

        "button.startSpeaking": "Ξεκινήστε ομιλία",
        "button.stopSpeaking": "Διακοπή εγγραφής",
        "button.tryAgain": "Δοκιμάστε ξανά",

        "listening.title": "Ακρόαση...",
        "listening.subtitle": "Μιλήστε φυσικά για αυτό που θέλετε να συμπληρώσετε",

        "processing.title": "Επεξεργασία...",
        "processing.subtitle": "Κατανοώ την είσοδό σας",
        "processing.analyzingForm": "Ανάλυση πεδίων φόρμας",

        "success.title": "Η φόρμα συμπληρώθηκε!",
        "success.subtitle": "Ελέγξτε τα συμπληρωμένα πεδία και υποβάλετε όταν είστε έτοιμοι",
        "success.what_was_filled": "Τι συμπληρώθηκε;",
        "success.you_said": "Είπατε",
        "success.we_translated": "Μεταφράσαμε",
        "success.apply_changes": "Συμπλήρωση και έλεγχος",
        "success.cancel_and_return": "Ακύρωση και επιστροφή στη φόρμα",
        "success.no_filled_data": "Δεν υπάρχουν δεδομένα για συμπληρωμένα πεδία",
        "success.unfilled_fields_title": "Ορισμένα πεδία δεν μπόρεσαν να συμπληρωθούν",
        "success.unfilled_fields_subtitle": "Παρακαλώ αναφέρετε αυτές τις τιμές πιο καθαρά:",
        "success.clarify_data": "Παρακαλώ διευκρινίστε αυτά τα δεδομένα:",
        "success.empty_fields": "Δεν συμπληρώθηκε",
        "success.check_fields": "Έλεγχος",
        "success.filled_fields": "Ολοκληρώθηκε",
        "success.field_single": "πεδίο",
        "success.fields_multiple": "πεδία",
        "success.require_filling": "απαιτούν συμπλήρωση",
        "success.require_attention": "απαιτούν προσοχή",
        "success.successfully_filled": "συμπληρώθηκε επιτυχώς",

        "error.microphone": "Απαιτείται πρόσβαση στο μικρόφωνο",
        "error.noFields": "Δεν εντοπίστηκαν φόρμες σε αυτήν τη σελίδα",
        "error.noActiveForm": "Δεν βρέθηκε ενεργή φόρμα για συμπλήρωση",
        "error.lowConfidence": "Δεν μπόρεσα να κατανοήσω καθαρά τον ήχο. Παρακαλώ μιλήστε πιο καθαρά.",
        "error.general": "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.",
        "error.no_fields_detected": "Δεν ήταν δυνατή η αναγνώριση πληροφοριών για τη συμπλήρωση της φόρμας. Παρακαλώ προσπαθήστε να προσδιορίσετε πιο καθαρά ποια δεδομένα πρέπει να εισαχθούν στα πεδία.",
        "error.no_data_title": "Τα δεδομένα δεν αναγνωρίστηκαν",
        "error.showDetails": "Εμφάνιση τεχνικών λεπτομερειών",

        "floatingButton.fillVoice1": "Υπαγόρευσε",
        "floatingButton.fillVoice2": "Συμπλήρωσε",

        "form.status.active": "ενεργή",
        "form.status.partial": "μερικώς συμπληρωμένη",
        "form.status.filled": "συμπληρωμένη",
        "form.progress.filled": "{count} συμπληρωμένα",
        "form.progress.partial": "{count} πεδίο μερικώς συμπληρωμένο",
        "form.progress.scrollToSelect": "Κύλιση για επιλογή",
        "form.defaultName": "Φόρμα",
        "form.formNumber": "Φόρμα {current} από {total}",
        "form.allForms": "Όλες οι {count} φόρμες"
    },
    cs: {
        "modal.title": "Řekněte nám o těchto tématech",
        "modal.subtitle": "Rozumíme jakémukoli jazyku, vyplníme vše a přeložíme, pokud je to potřeba",

        "loader.initial": "Příprava formuláře...",

        "button.startSpeaking": "Začněte mluvit",
        "button.stopSpeaking": "Zastavit nahrávání",
        "button.tryAgain": "Zkusit znovu",

        "listening.title": "Poslouchám...",
        "listening.subtitle": "Mluvte přirozeně o tom, co chcete vyplnit",

        "processing.title": "Zpracovávám...",
        "processing.subtitle": "Rozumím vašemu vstupu",
        "processing.analyzingForm": "Analyzuji pole formuláře",

        "success.title": "Formulář vyplněn!",
        "success.subtitle": "Zkontrolujte vyplněná pole a odešlete, až budete připraveni",
        "success.what_was_filled": "Co bylo vyplněno?",
        "success.you_said": "Řekli jste",
        "success.we_translated": "Přeložili jsme",
        "success.apply_changes": "Vyplnit a zkontrolovat",
        "success.cancel_and_return": "Zrušit a vrátit se k formuláři",
        "success.no_filled_data": "Žádné údaje o vyplněných polích",
        "success.unfilled_fields_title": "Některá pole se nepodařilo vyplnit",
        "success.unfilled_fields_subtitle": "Prosím, uveďte tyto hodnoty jasněji:",
        "success.clarify_data": "Prosím upřesněte tyto údaje:",
        "success.empty_fields": "Nevyplněno",
        "success.check_fields": "Zkontrolovat",
        "success.filled_fields": "Dokončeno",
        "success.field_single": "pole",
        "success.fields_multiple": "pole",
        "success.require_filling": "vyžadují vyplnění",
        "success.require_attention": "vyžadují pozornost",
        "success.successfully_filled": "úspěšně vyplněno",

        "error.microphone": "Vyžadován přístup k mikrofonu",
        "error.noFields": "Na této stránce nebyly nalezeny žádné formuláře",
        "error.noActiveForm": "Nebyl nalezen žádný aktivní formulář k vyplnění",
        "error.lowConfidence": "Nepodařilo se jasně rozpoznat zvuk. Prosím, mluvte zřetelněji.",
        "error.general": "Něco se pokazilo. Zkuste to prosím znovu.",
        "error.no_fields_detected": "Nepodařilo se rozpoznat informace pro vyplnění formuláře. Zkuste prosím jasněji určit, jaká data mají být zadána do polí.",
        "error.no_data_title": "Data nebyla rozpoznána",
        "error.showDetails": "Zobrazit technické podrobnosti",

        "floatingButton.fillVoice1": "Diktuj",
        "floatingButton.fillVoice2": "Vyplň",

        "form.status.active": "aktivní",
        "form.status.partial": "částečně vyplněný",
        "form.status.filled": "vyplněný",
        "form.progress.filled": "{count} vyplněno",
        "form.progress.partial": "{count} pole částečně vyplněno",
        "form.progress.scrollToSelect": "Rolujte pro výběr",
        "form.defaultName": "Formulář",
        "form.formNumber": "Formulář {current} z {total}",
        "form.allForms": "Všechny {count} formuláře"
    },
    hu: {
        "modal.title": "Mondd el nekünk ezeket a témákat",
        "modal.subtitle": "Bármely nyelvet értünk, mindent kitöltünk, és ha kell, fordítunk",

        "loader.initial": "Űrlap előkészítése...",

        "button.startSpeaking": "Kezdj el beszélni",
        "button.stopSpeaking": "Felvétel leállítása",
        "button.tryAgain": "Próbáld újra",

        "listening.title": "Hallgatás...",
        "listening.subtitle": "Beszélj természetesen arról, amit ki szeretnél tölteni",

        "processing.title": "Feldolgozás...",
        "processing.subtitle": "Értem a bevitelt",
        "processing.analyzingForm": "Űrlap mezők elemzése",

        "success.title": "Űrlap kitöltve!",
        "success.subtitle": "Ellenőrizd a kitöltött mezőket, és küldd el, ha készen állsz",
        "success.what_was_filled": "Mi lett kitöltve?",
        "success.you_said": "Ezt mondtad",
        "success.we_translated": "Lefordítottuk",
        "success.apply_changes": "Kitöltés és ellenőrzés",
        "success.cancel_and_return": "Mégse és vissza az űrlaphoz",
        "success.no_filled_data": "Nincs adat a kitöltött mezőkről",
        "success.unfilled_fields_title": "Néhány mezőt nem sikerült kitölteni",
        "success.unfilled_fields_subtitle": "Kérjük, említsd meg ezeket az értékeket világosabban:",
        "success.clarify_data": "Kérjük, pontosítsa ezeket az adatokat:",
        "success.empty_fields": "Nincs kitöltve",
        "success.check_fields": "Ellenőrzés",
        "success.filled_fields": "Befejezve",
        "success.field_single": "mező",
        "success.fields_multiple": "mező",
        "success.require_filling": "kitöltést igényel",
        "success.require_attention": "figyelmet igényel",
        "success.successfully_filled": "sikeresen kitöltve",

        "error.microphone": "Mikrofonhozzáférés szükséges",
        "error.noFields": "Nem található űrlap ezen az oldalon",
        "error.noActiveForm": "Nem található aktív űrlap a kitöltéshez",
        "error.lowConfidence": "Nem sikerült tisztán érteni a hangot. Kérlek, beszélj érthetőbben.",
        "error.general": "Valami elromlott. Kérlek, próbáld újra.",
        "error.no_fields_detected": "Nem sikerült felismerni az űrlap kitöltéséhez szükséges információkat. Kérjük, próbálja meg világosabban megadni, hogy milyen adatokat kell beírni a mezőkbe.",
        "error.no_data_title": "Az adatok nem voltak felismerhetők",
        "error.showDetails": "Technikai részletek megjelenítése",

        "floatingButton.fillVoice1": "Diktálj",
        "floatingButton.fillVoice2": "Töltsd ki",

        "form.status.active": "aktív",
        "form.status.partial": "részben kitöltött",
        "form.status.filled": "kitöltött",
        "form.progress.filled": "{count} kitöltött",
        "form.progress.partial": "{count} mező részben kitöltve",
        "form.progress.scrollToSelect": "Görgess a kiválasztáshoz",
        "form.defaultName": "Űrlap",
        "form.formNumber": "Űrlap {current} / {total}",
        "form.allForms": "Összes {count} űrlap"
    },
    ro: {
        "modal.title": "Vorbește-ne despre aceste subiecte",
        "modal.subtitle": "Înțelegem orice limbă, completăm totul și traducem dacă este necesar",

        "loader.initial": "Pregătesc formularul...",

        "button.startSpeaking": "Începe să vorbești",
        "button.stopSpeaking": "Oprește înregistrarea",
        "button.tryAgain": "Încearcă din nou",

        "listening.title": "Ascult...",
        "listening.subtitle": "Vorbește natural despre ceea ce vrei să completezi",

        "processing.title": "Se procesează...",
        "processing.subtitle": "Înțeleg intrarea ta",
        "processing.analyzingForm": "Analizez câmpurile formularului",

        "success.title": "Formular completat!",
        "success.subtitle": "Revizuiește câmpurile completate și trimite când ești gata",
        "success.what_was_filled": "Ce a fost completat?",
        "success.you_said": "Ai spus",
        "success.we_translated": "Am tradus",
        "success.apply_changes": "Completează și verifică",
        "success.cancel_and_return": "Anulează și întoarce-te la formular",
        "success.no_filled_data": "Nu există date despre câmpurile completate",
        "success.unfilled_fields_title": "Unele câmpuri nu au putut fi completate",
        "success.unfilled_fields_subtitle": "Te rog menționează aceste valori mai clar:",
        "success.clarify_data": "Vă rugăm să clarificați aceste date:",
        "success.empty_fields": "Necompletat",
        "success.check_fields": "Verifică",
        "success.filled_fields": "Completat",
        "success.field_single": "câmp",
        "success.fields_multiple": "câmpuri",
        "success.require_filling": "necesită completare",
        "success.require_attention": "necesită atenție",
        "success.successfully_filled": "completat cu succes",

        "error.microphone": "Accesul la microfon este necesar",
        "error.noFields": "Nu au fost detectate formulare pe această pagină",
        "error.noActiveForm": "Nu s-a găsit niciun formular activ pentru completare",
        "error.lowConfidence": "Nu am putut înțelege clar audio-ul. Te rog vorbește mai clar.",
        "error.general": "Ceva nu a mers bine. Te rog, încearcă din nou.",
        "error.no_fields_detected": "Nu s-au putut recunoaște informațiile pentru completarea formularului. Vă rugăm să încercați să specificați mai clar ce date trebuie introduse în câmpuri.",
        "error.no_data_title": "Datele nu au fost recunoscute",
        "error.showDetails": "Afișează detalii tehnice",

        "floatingButton.fillVoice1": "Dictează",
        "floatingButton.fillVoice2": "Completează",

        "form.status.active": "activ",
        "form.status.partial": "parţial completat",
        "form.status.filled": "completat",
        "form.progress.filled": "{count} completat",
        "form.progress.partial": "{count} câmp parţial completat",
        "form.progress.scrollToSelect": "Derulează pentru a selecta",
        "form.defaultName": "Formular",
        "form.formNumber": "Formular {current} din {total}",
        "form.allForms": "Toate cele {count} formulare"
    },
    bg: {
        "modal.title": "Разкажете ни за тези теми",
        "modal.subtitle": "Разбираме всеки език, попълваме всичко и превеждаме при нужда",

        "button.startSpeaking": "Започнете да говорите",
        "button.stopSpeaking": "Спрете записа",
        "button.tryAgain": "Опитайте отново",

        "listening.title": "Слушам...",
        "listening.subtitle": "Говорете естествено за това, което искате да попълните",

        "processing.title": "Обработва се...",
        "processing.subtitle": "Разбирам вашия вход",

        "success.title": "Формата е попълнена!",
        "success.subtitle": "Прегледайте попълнените полета и изпратете, когато сте готови",
        "success.what_was_filled": "Какво беше попълнено?",

        "error.microphone": "Изисква се достъп до микрофон",
        "error.noFields": "Не са открити форми на тази страница",
        "error.general": "Нещо се обърка. Моля, опитайте отново.",
        "error.no_fields_detected": "Не можа да се разпознае информацията за попълване на формата. Моля, опитайте да посочите по-ясно какви данни трябва да бъдат въведени в полетата.",
        "error.no_data_title": "Данните не са разпознати",
        "error.showDetails": "Покажи технически подробности",

        "floatingButton.fillVoice1": "Диктувай",
        "floatingButton.fillVoice2": "Попълвай",

        "form.status.active": "активна",
        "form.status.partial": "частично попълнена",
        "form.status.filled": "попълнена",
        "form.progress.filled": "{count} попълнени",
        "form.progress.partial": "{count} поле частично заполнено",
        "form.progress.scrollToSelect": "Превъртете за избор",
        "form.defaultName": "Формуляр",
        "form.formNumber": "Формуляр {current} от {total}",
        "form.allForms": "Всички {count} формуляра",

        "loader.initial": "Подготовка на формата...",
        "processing.analyzingForm": "Анализиране на полетата на формата",
        
        "success.you_said": "Казахте",
        "success.we_translated": "Преведохме",
        "success.apply_changes": "Попълни и провери",
        "success.cancel_and_return": "Отмени и се върни към формата",
        "success.no_filled_data": "Няма данни за попълнените полета",
        "success.unfilled_fields_title": "Някои полета не можаха да бъдат попълнени",
        "success.unfilled_fields_subtitle": "Моля, споменете тези стойности по-ясно:",
        "success.clarify_data": "Моля, уточнете тези данни:",
        "success.empty_fields": "Непопълнено",
        "success.check_fields": "Проверете",
        "success.filled_fields": "Завършено",
        "success.field_single": "поле",
        "success.fields_multiple": "полета",
        "success.require_filling": "изискват попълване",
        "success.require_attention": "изискват внимание",
        "success.successfully_filled": "успешно попълнено",
        
        "error.noActiveForm": "Не е намерена активна форма за попълване",
        "error.lowConfidence": "Не можах да разбера ясно аудиото. Моля, говорете по-ясно."
    },
    sk: {
        "modal.title": "Povedzte nám o týchto témach",
        "modal.subtitle": "Rozumieme akémukoľvek jazyku, vyplníme všetko a preložíme, ak je to potrebné",

        "button.startSpeaking": "Začnite hovoriť",
        "button.stopSpeaking": "Zastaviť nahrávanie",
        "button.tryAgain": "Skúsiť znova",

        "listening.title": "Počúvam...",
        "listening.subtitle": "Hovorte prirodzene o tom, čo chcete vyplniť",

        "processing.title": "Spracováva sa...",
        "processing.subtitle": "Rozumiem vášmu vstupu",

        "success.title": "Formulár vyplnený!",
        "success.subtitle": "Skontrolujte vyplnené polia a odošlite, keď ste pripravení",
        "success.what_was_filled": "Čo bolo vyplnené?",

        "error.microphone": "Vyžaduje sa prístup k mikrofónu",
        "error.noFields": "Na tejto stránke neboli nájdené žiadne formuláre",
        "error.general": "Niečo sa pokazilo. Skúste to prosím znova.",
        "error.no_fields_detected": "Nepodarilo sa rozpoznať informácie na vyplnenie formulára. Skúste prosím jasnejšie určiť, aké údaje majú byť zadané do polí.",
        "error.no_data_title": "Údaje neboli rozpoznané",
        "error.showDetails": "Zobraziť technické podrobnosti",

        "floatingButton.fillVoice1": "Diktuj",
        "floatingButton.fillVoice2": "Vyplň",

        "form.status.active": "aktívny",
        "form.status.partial": "čiastočne vyplnený",
        "form.status.filled": "vyplnený",
        "form.progress.filled": "{count} vyplnené",
        "form.progress.partial": "{count} pole čiastočne vyplnené",
        "form.progress.scrollToSelect": "Posúvajte pre výber",
        "form.defaultName": "Formulár",
        "form.formNumber": "Formulár {current} z {total}",
        "form.allForms": "Všetky {count} formuláre",

        "loader.initial": "Príprava formulára...",
        "processing.analyzingForm": "Analyzujem polia formulára",
        
        "success.you_said": "Povedali ste",
        "success.we_translated": "Preložili sme",
        "success.apply_changes": "Vyplniť a skontrolovať",
        "success.cancel_and_return": "Zrušiť a vrátiť sa k formuláru",
        "success.no_filled_data": "Žiadne údaje o vyplnených poliach",
        "success.unfilled_fields_title": "Niektoré polia sa nepodarilo vyplniť",
        "success.unfilled_fields_subtitle": "Prosím, uveďte tieto hodnoty jasnejšie:",
        "success.clarify_data": "Prosím, upresnte tieto údaje:",
        "success.empty_fields": "Nevyplnené",
        "success.check_fields": "Skontrolovať",
        "success.filled_fields": "Dokončené",
        "success.field_single": "pole",
        "success.fields_multiple": "polia",
        "success.require_filling": "vyžadujú vyplnenie",
        "success.require_attention": "vyžadujú pozornosť",
        "success.successfully_filled": "úspešne vyplnené",
        
        "error.noActiveForm": "Nenašiel sa žiadny aktívny formulár na vyplnenie",
        "error.lowConfidence": "Nepodarilo sa jasne rozpoznať zvuk. Prosím, hovorte zreteľnejšie."
    },
    hr: {
        "modal.title": "Recite nam o ovim temama",
        "modal.subtitle": "Razumijemo bilo koji jezik, ispunjavamo sve i prevodimo ako je potrebno",

        "button.startSpeaking": "Počni govoriti",
        "button.stopSpeaking": "Zaustavi snimanje",
        "button.tryAgain": "Pokušajte ponovo",

        "listening.title": "Slušam...",
        "listening.subtitle": "Govorite prirodno o onome što želite ispuniti",

        "processing.title": "Obrađuje se...",
        "processing.subtitle": "Razumijem vaš unos",

        "success.title": "Obrazac ispunjen!",
        "success.subtitle": "Pregledajte ispunjena polja i pošaljite kada ste spremni",
        "success.what_was_filled": "Što je ispunjeno?",

        "error.microphone": "Potrebno je dopuštenje za mikrofon",
        "error.noFields": "Nema obrazaca pronađenih na ovoj stranici",
        "error.general": "Nešto je pošlo po krivu. Pokušajte ponovno.",
        "error.no_fields_detected": "Nije moguće prepoznati informacije za ispunjavanje obrasca. Molimo pokušajte jasnije navesti koje podatke treba unijeti u polja.",
        "error.no_data_title": "Podaci nisu prepoznati",
        "error.showDetails": "Prikaži tehničke detalje",

        "floatingButton.fillVoice1": "Diktiraj",
        "floatingButton.fillVoice2": "Ispuni",

        "form.status.active": "aktivna",
        "form.status.partial": "djelomično ispunjena",
        "form.status.filled": "ispunjena",
        "form.progress.filled": "{count} ispunjeno",
        "form.progress.partial": "{count} polje djelomično ispunjeno",
        "form.progress.scrollToSelect": "Skroluj za odabir",
        "form.defaultName": "Obrazac",
        "form.formNumber": "Obrazac {current} od {total}",
        "form.allForms": "Svi {count} obrasci",

        "loader.initial": "Priprema obrasca...",
        "processing.analyzingForm": "Analiziram polja obrasca",
        
        "success.you_said": "Rekli ste",
        "success.we_translated": "Preveli smo",
        "success.apply_changes": "Ispuni i provjeri",
        "success.cancel_and_return": "Otkaži i vrati se na obrazac",
        "success.no_filled_data": "Nema podataka o ispunjenim poljima",
        "success.unfilled_fields_title": "Neka polja nisu mogla biti ispunjena",
        "success.unfilled_fields_subtitle": "Molimo spomenite ove vrijednosti jasnije:",
        "success.clarify_data": "Molimo pojasnite ove podatke:",
        "success.empty_fields": "Nije ispunjeno",
        "success.check_fields": "Provjeri",
        "success.filled_fields": "Dovršeno",
        "success.field_single": "polje",
        "success.fields_multiple": "polja",
        "success.require_filling": "zahtijevaju ispunjavanje",
        "success.require_attention": "zahtijevaju pažnju",
        "success.successfully_filled": "uspješno ispunjeno",
        
        "error.noActiveForm": "Nije pronađen aktivni obrazac za ispunjavanje",
        "error.lowConfidence": "Nisam mogao jasno razumjeti zvuk. Molimo govorite jasnije."
    },
    sr: {
        "modal.title": "Reci nam o ovim temama",
        "modal.subtitle": "Razumemo sve jezike, popunimo sve i prevedemo po potrebi",

        "button.startSpeaking": "Počni da govoriš",
        "button.stopSpeaking": "Zaustavi snimanje",
        "button.tryAgain": "Pokušaj ponovo",

        "listening.title": "Slušam...",
        "listening.subtitle": "Prirodno govori o tome šta želiš da popuniš",

        "processing.title": "Obrađujem...",
        "processing.subtitle": "Razumem vaš unos",

        "success.title": "Obrazac popunjen!",
        "success.subtitle": "Pregledaj popunjena polja i pošalji kada si spreman",
        "success.what_was_filled": "Šta je popunjeno?",

        "error.microphone": "Potreban pristup mikrofonu",
        "error.noFields": "Na ovoj stranici nisu pronađeni obrasci",
        "error.general": "Nešto je pošlo po zlu. Molim pokušaj ponovo.",
        "error.no_fields_detected": "Nije moguće prepoznati informacije za popunjavanje obrasca. Molimo pokušajte jasnije navesti koje podatke treba uneti u polja.",
        "error.no_data_title": "Podaci nisu prepoznati",
        "error.showDetails": "Prikaži tehničke detalje",

        "floatingButton.fillVoice1": "Diktiraj",
        "floatingButton.fillVoice2": "Popuni",

        "form.status.active": "aktivna",
        "form.status.partial": "delimično popunjena",
        "form.status.filled": "popunjena",
        "form.progress.filled": "{count} popunjeno",
        "form.progress.partial": "{count} polje delimično popunjeno",
        "form.progress.scrollToSelect": "Skroluj za odabir",
        "form.defaultName": "Obrazac",
        "form.formNumber": "Obrazac {current} od {total}",
        "form.allForms": "Svi {count} obrasci",

        "loader.initial": "Priprema obrasca...",
        "processing.analyzingForm": "Analiziram polja obrasca",
        
        "success.you_said": "Rekli ste",
        "success.we_translated": "Preveli smo",
        "success.apply_changes": "Popuni i proveri",
        "success.cancel_and_return": "Otkaži i vrati se na obrazac",
        "success.no_filled_data": "Nema podataka o popunjenim poljima",
        "success.unfilled_fields_title": "Neka polja nisu mogla biti popunjena",
        "success.unfilled_fields_subtitle": "Molimo pomenite ove vrednosti jasnije:",
        "success.clarify_data": "Molimo pojasnite ove podatke:",
        "success.empty_fields": "Није попуњено",
        "success.check_fields": "Провери",
        "success.filled_fields": "Завршено",
        "success.field_single": "поље",
        "success.fields_multiple": "поља",
        "success.require_filling": "захтевају попуњавање",
        "success.require_attention": "захтевају пажњу",
        "success.successfully_filled": "успешно попуњено",
        
        "error.noActiveForm": "Nije pronađen aktivan obrazac za popunjavanje",
        "error.lowConfidence": "Nisam mogao jasno da razumem zvuk. Molimo govorite jasnije."
    },
    uk: {
        "modal.title": "Розкажіть нам про ці теми",
        "modal.subtitle": "Ми розуміємо будь-яку мову, заповнюємо все і, за потреби, перекладаємо",

        "button.startSpeaking": "Почніть говорити",
        "button.stopSpeaking": "Зупиніть запис",
        "button.tryAgain": "Спробуйте ще раз",

        "listening.title": "Слухаю...",
        "listening.subtitle": "Говоріть природно про те, що хочете заповнити",

        "processing.title": "Обробка...",
        "processing.subtitle": "Розумію ваш введений текст",

        "success.title": "Форму заповнено!",
        "success.subtitle": "Перегляньте заповнені поля та надішліть, коли будете готові",
        "success.what_was_filled": "Що було заповнено?",

        "error.microphone": "Потрібен доступ до мікрофона",
        "error.noFields": "Не виявлено форм на цій сторінці",
        "error.general": "Щось пішло не так. Будь ласка, спробуйте ще раз.",
        "error.no_fields_detected": "Не вдалося розпізнати інформацію для заповнення форми. Спробуйте чіткіше вказати, які дані потрібно ввести в поля.",
        "error.no_data_title": "Дані не розпізнано",
        "error.showDetails": "Показати технічні деталі",

        "floatingButton.fillVoice1": "Диктуй",
        "floatingButton.fillVoice2": "Заповнюй",

        "form.status.active": "активна",
        "form.status.partial": "частково заповнена",
        "form.status.filled": "заповнена",
        "form.progress.filled": "{count} заповнено",
        "form.progress.partial": "{count} поле частково заповнено",
        "form.progress.scrollToSelect": "Прокрутіть для вибору",
        "form.defaultName": "Форма",
        "form.formNumber": "Форма {current} з {total}",
        "form.allForms": "Усі {count} форми",

        "loader.initial": "Підготовка форми...",
        "processing.analyzingForm": "Аналізую поля форми",
        
        "success.you_said": "Ви сказали",
        "success.we_translated": "Ми переклали",
        "success.apply_changes": "Заповнити та перевірити",
        "success.cancel_and_return": "Скасувати та повернутися до форми",
        "success.no_filled_data": "Немає даних про заповнені поля",
        "success.unfilled_fields_title": "Деякі поля не вдалося заповнити",
        "success.unfilled_fields_subtitle": "Будь ласка, вкажіть ці значення чіткіше:",
        "success.clarify_data": "Уточніть ці дані:",
        "success.empty_fields": "Незаповнено",
        "success.check_fields": "Перевірити",
        "success.filled_fields": "Завершено",
        "success.field_single": "поле",
        "success.fields_multiple": "поля",
        "success.require_filling": "потребують заповнення",
        "success.require_attention": "потребують уваги",
        "success.successfully_filled": "успішно заповнено",
        
        "error.noActiveForm": "Не знайдено активної форми для заповнення",
        "error.lowConfidence": "Не вдалося чітко розпізнати мову. Будь ласка, говоріть виразніше."
    },
    ko: {
        "modal.title": "이 주제들에 대해 알려주세요",
        "modal.subtitle": "모든 언어를 이해하며, 필요하다면 자동으로 채우고 번역합니다",

        "button.startSpeaking": "말하기 시작",
        "button.stopSpeaking": "녹음 중지",
        "button.tryAgain": "다시 시도",

        "listening.title": "듣는 중...",
        "listening.subtitle": "채우고 싶은 내용을 자연스럽게 말하세요",

        "processing.title": "처리 중...",
        "processing.subtitle": "입력을 이해하는 중",

        "success.title": "양식이 채워졌습니다!",
        "success.subtitle": "채워진 필드를 검토하고 준비되면 제출하세요",
        "success.what_was_filled": "무엇이 작성되었나요?",

        "error.microphone": "마이크 접근이 필요합니다",
        "error.noFields": "이 페이지에서 양식이 감지되지 않았습니다",
        "error.general": "문제가 발생했습니다. 다시 시도해주세요.",
        "error.no_fields_detected": "양식을 채우기 위한 정보를 인식할 수 없었습니다. 필드에 입력해야 할 데이터를 더 명확하게 지정해 주세요.",
        "error.no_data_title": "데이터가 인식되지 않았습니다",
        "error.showDetails": "기술적 세부사항 표시",

        "floatingButton.fillVoice1": "구술",
        "floatingButton.fillVoice2": "작성",

        "form.status.active": "활성",
        "form.status.partial": "부분 작성됨",
        "form.status.filled": "작성됨",
        "form.progress.filled": "{count}개 작성됨",
        "form.progress.partial": "{count}개 필드 부분적으로 채워짐",
        "form.progress.scrollToSelect": "스크롤하여 선택",
        "form.defaultName": "양식",
        "form.formNumber": "양식 {current} / {total}",
        "form.allForms": "모든 {count}개 양식",

        "loader.initial": "양식 준비 중...",
        "processing.analyzingForm": "양식 필드 분석 중",
        
        "success.you_said": "당신이 말한 것",
        "success.we_translated": "번역한 내용",
        "success.apply_changes": "작성 및 검토",
        "success.cancel_and_return": "취소하고 양식으로 돌아가기",
        "success.no_filled_data": "채워진 필드에 대한 데이터가 없습니다",
        "success.unfilled_fields_title": "일부 필드를 채울 수 없었습니다",
        "success.unfilled_fields_subtitle": "이 값들을 더 명확하게 언급해주세요:",
        "success.clarify_data": "이 데이터를 명확히 해주세요:",
        "success.empty_fields": "입력되지 않음",
        "success.check_fields": "확인",
        "success.filled_fields": "완료",
        "success.field_single": "필드",
        "success.fields_multiple": "필드",
        "success.require_filling": "입력이 필요합니다",
        "success.require_attention": "주의가 필요합니다",
        "success.successfully_filled": "성공적으로 입력되었습니다",
        
        "error.noActiveForm": "채울 활성 양식을 찾을 수 없습니다",
        "error.lowConfidence": "오디오를 명확하게 이해할 수 없었습니다. 더 또렷하게 말씀해주세요."
    }
};
